import { render } from "./Preloader.vue?vue&type=template&id=2cf9fea4&scoped=true"
const script = {}

import "./Preloader.vue?vue&type=style&index=0&id=2cf9fea4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf9fea4"]])

export default __exports__